import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import StepsSection from "./components/StepsSection";
import { heroData, finalCTA } from "../../mocks/bookingFlowData";

export default function BookingFlow() {
  return (
    <PageLayout>
      <InfoPageHero
        label="BOOKING FLOW"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="ご予約の流れ"
      />
      <StepsSection />
      <InfoPageFinalCTA
        title={finalCTA.title}
        subtitle={finalCTA.subtitle}
        ctas={finalCTA.ctas}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
